import { render, staticRenderFns } from "./FireblocksCustodialInput.vue?vue&type=template&id=a823962a&"
import script from "./FireblocksCustodialInput.vue?vue&type=script&lang=ts&"
export * from "./FireblocksCustodialInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports